/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeKrListRespVo } from './GetDeliverFeeKrListRespVo';
import {
    GetDeliverFeeKrListRespVoFromJSON,
    GetDeliverFeeKrListRespVoFromJSONTyped,
    GetDeliverFeeKrListRespVoToJSON,
    GetDeliverFeeKrListRespVoToJSONTyped,
} from './GetDeliverFeeKrListRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetDeliverFeeKrListRespVo
 */
export interface ResponseListGetDeliverFeeKrListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetDeliverFeeKrListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetDeliverFeeKrListRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetDeliverFeeKrListRespVo>}
     * @memberof ResponseListGetDeliverFeeKrListRespVo
     */
    data?: Array<GetDeliverFeeKrListRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetDeliverFeeKrListRespVo interface.
 */
export function instanceOfResponseListGetDeliverFeeKrListRespVo(value: object): value is ResponseListGetDeliverFeeKrListRespVo {
    return true;
}

export function ResponseListGetDeliverFeeKrListRespVoFromJSON(json: any): ResponseListGetDeliverFeeKrListRespVo {
    return ResponseListGetDeliverFeeKrListRespVoFromJSONTyped(json, false);
}

export function ResponseListGetDeliverFeeKrListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetDeliverFeeKrListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetDeliverFeeKrListRespVoFromJSON)),
    };
}

export function ResponseListGetDeliverFeeKrListRespVoToJSON(json: any): ResponseListGetDeliverFeeKrListRespVo {
    return ResponseListGetDeliverFeeKrListRespVoToJSONTyped(json, false);
}

export function ResponseListGetDeliverFeeKrListRespVoToJSONTyped(value?: ResponseListGetDeliverFeeKrListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetDeliverFeeKrListRespVoToJSON)),
    };
}

